
export const name = "DashboardUI";
export const version = "dev";
